import { Injectable, Inject, DOCUMENT } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AARouterURL } from '../../app-routing/enums/routing.enum';
@Injectable()
export class SeoMetaService {

  public readonly routePlannerRoute: string = 'https://www.theaa.com/route-planner/';

  constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private dom,
    private location: Location, private http: HttpClient) { }

  public cononicalURL(routeType: AARouterURL, params?: string): string {
    let path = `${this.routePlannerRoute}${routeType}`;

    if (params) {
      path = `${path}/${params}`;
    }
    return path;
  }

  updateTitle(title: string) {
    this.title.setTitle(title);
  }

  updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc });
  }

  public updateCanonicalURL(url?: string): void {
    // let canURL = url == undefined ? this.dom.URL : url;
    let updatedLink  = false;
    const links = document.getElementsByTagName('link');
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      if (link.getAttribute('rel').indexOf('canonical') != -1) {
        link.href = url;
        updatedLink = true;
      }
    }
    // in case we are not finding the canonical tag, add the new link.
    if (!updatedLink) {
      this.createLinkForCanonicalURL(url);
    }
  }

  private createLinkForCanonicalURL(url: string) {
    const link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', url);
  }

  trafficNewsUpdateCanonicalURL(url?: string) {

    let location = '';
    let preRenderUrls: Array<string> = [];
    this.http.get('assets/prerender/route.txt', { responseType: 'text' as 'json' }).pipe(
        map(d => {
            preRenderUrls.push(d.toString());
        })
      ).subscribe(urls => {
        preRenderUrls.length > 0 ? preRenderUrls = preRenderUrls[0].split(/\r?\n/g) : null;
        location = `${AARouterURL.TRAFFIC_NEWS}/${url}`;
        if (preRenderUrls.filter(u => u == location).length > 0) {
            this.updateCanonicalURL(this.routePlannerRoute + location);
        } else {
            this.updateCanonicalURL( this.cononicalURL(AARouterURL.TRAFFIC_NEWS) );
        }
    });
  }
}
